import { DocsApiError } from "../docsapi/docsapi.atom";

/**
 * Base class for workspace billing related errors.
 * @info Wc = Workspace Checkout
 * @info WaStatus = Workspace Account Status
 */
class WorkspaceBillingError extends DocsApiError {
	constructor(message: string, error?: unknown) {
		super(message, undefined, error);
		this.name = "WorkspaceBillingError";
	}
}

export class WcWorkspaceRequiredError extends WorkspaceBillingError {
	public readonly tag = "workspace-checkout-workspace-required-error" as const;

	constructor() {
		super("Workspace is required to manage billing");
		this.name = "WcWorkspaceRequiredError";
	}
}

export class WcAuthRequiredError extends WorkspaceBillingError {
	public readonly tag = "workspace-checkout-auth-required-error" as const;

	constructor() {
		super("You must be authenticated to manage billing");
		this.name = "WcAuthRequiredError";
	}
}

export class WcAccessTokenMissingError extends WorkspaceBillingError {
	public readonly tag = "workspace-checkout-access-token-missing-error" as const;

	constructor() {
		super("Unauthenticated: cannot create checkout");
		this.name = "WcAccessTokenMissingError";
	}
}

export class WcSessionCreationError extends WorkspaceBillingError {
	public readonly tag = "workspace-checkout-session-creation-error" as const;

	constructor(error?: unknown) {
		const message =
			error instanceof Error
				? `Failed to create checkout session: ${error.message}`
				: "Failed to create checkout session";
		super(message, error);
		this.name = "WcSessionCreationError";
	}
}

export class WaStatusWorkspaceRequiredError extends WorkspaceBillingError {
	public readonly tag = "workspace-account-status-workspace-required-error" as const;

	constructor() {
		super("Workspace is required to query billing status");
		this.name = "WaStatusWorkspaceRequiredError";
	}
}

export class WaStatusAuthRequiredError extends WorkspaceBillingError {
	public readonly tag = "workspace-account-status-auth-required-error" as const;

	constructor() {
		super("You must be authenticated to query billing status");
		this.name = "WaStatusAuthRequiredError";
	}
}

export class WaStatusAccessTokenMissingError extends WorkspaceBillingError {
	public readonly tag = "workspace-account-status-access-token-missing-error" as const;

	constructor() {
		super("Unauthenticated: cannot query billing status");
		this.name = "WaStatusAccessTokenMissingError";
	}
}

export class WaStatusSyncError extends WorkspaceBillingError {
	public readonly tag = "workspace-account-status-sync-error" as const;

	constructor(error?: unknown) {
		const message =
			error instanceof Error
				? `Failed to sync workspace billing status: ${error.message}`
				: "Failed to sync workspace billing status";
		super(message, error);
		this.name = "WaStatusSyncError";
	}
}

export class WaStatusFetchError extends WorkspaceBillingError {
	public readonly tag = "workspace-account-status-fetch-error" as const;

	constructor(error?: unknown) {
		const message =
			error instanceof Error
				? `Failed to fetch workspace billing status: ${error.message}`
				: "Failed to fetch workspace billing status";
		super(message, error);
		this.name = "WaStatusFetchError";
	}
}
